import superagent from 'superagent';

const apiMiddleware = config => store => next => action => {
  if (action.type === 'API_REQUEST') {
    return makeApiRequest(store, action, config);
  } else {
    return next(action);
  }
};

function makeApiRequest(store, action, config) {
  const { service, method, path, query, handleResponse, handleError } = action;

  const state = store.getState();
  const user = state.login.user;
  const { lat, lng } = state.address;

  const baseUrl = getBaseUrl(service, config);

  const request = superagent(method || 'GET', baseUrl + path);

  if (query) request.query(query);

  request.set('x-platform', 'web');
  if (lat && lng) request.query({ lat, lng });
  if (user) request.set('x-user', user.id || user.objectId);

  return request
    .then(res => {
      return handleResponse ? handleResponse(res) : res.body;
    })
    .catch(err => {
      if (handleError) {
        return handleError(err);
      } else {
        throw new Error(err);
      }
    });
}

function getBaseUrl(service, config) {
  const services = {
    MENU: config.menuURL,
    BRAND_TEMPLATES: config.brandTemplateURL
  };

  return services[service] || '';
}

export default apiMiddleware;
